import { useTranslation } from 'react-i18next'

const BigSisterEnd = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="bigsister-after-title"
      {...props}
    >
      <title id="bigsister-after-title">{t('antagonists:bigsister:components:end')}</title>
      <defs>
        <clipPath id="bigsister-b">
          <path
            d="M1589.26 516.45s1.29-20.98-9.47-39.59c-24.45-42.3-19.14-69.21-19.14-69.21s-67.55 15.14-91.68 18.79c-24.12 3.65-42.16 13.76-42.89 51.06-.73 37.3 30.71 148.42 23.39 195.94-7.32 47.52-37.3 96.51-32.17 120.63 5.11 24.12 29.25 32.9 28.52 43.87-.73 10.97 1.32 41.1 1.32 41.1s69.59 15.94 117.85 14.48c48.26-1.46 167.07-14.48 167.07-14.48s-5.58-28.19 6.85-36.97c12.43-8.78 17.08-11.73 17.83-35.12.73-23.39-29.42-89.66-22.11-132.8 7.32-43.14 3.65-110.4 21.2-149.15 17.55-38.76 21.2-58.5 3.65-70.2-17.55-11.7-106.38-41.87-106.38-41.87s-2.33 14.25-13.71 30.97c-9.75 14.32-26.09 27.29-30.81 34.71-10.24 16.09-12.86 36.97-12.86 36.97l-6.45.85-.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.c{fill:none}.d{fill:#f9cec6}.e{fill:#e6ab00}.f{fill:#de9766}.g{fill:#c48648}.h{fill:#245787}.i{fill:#1c3628}.j{clip-path:url(#bigsister-b)}'
          }
        </style>
      </defs>
      <path
        d="M1610.2 374.47c-70.04-6.34-90.15-2.55-98.93 18.65-8.78 21.2 27.16 131.74 27.16 131.74l83.94 17.36s36.62-44.58 63.68-72.35c27.06-27.79 25.17-58.36 19.33-75.17-5.86-16.82-36.08-14.86-95.17-20.21l-.02-.02Z"
        style={{
          fill: '#e6ab00',
        }}
      />
      <path
        style={{
          fill: '#f9cec6',
        }}
        d="m1592.79 422.32 66.41 2.31-66.41 118.67h-45.33l-31.21-109.91 76.54-11.07z"
      />
      <path
        d="M1551.11 341.5s12.1 58.43 9.51 71.66c-2.31 11.84 7.09 32.45 32.69 33.18s48.47-6.14 55.06-14.89c6.59-8.78 5.86-90.37 5.86-90.37l-103.1.45-.02-.02Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1548.17 794.71c53.3 7.35 176.46-2.76 171.87-1.84-4.59.92 19.31 116.72 13.78 200.35l-5.51 83.63s0 59.73 10.11 103.86c10.11 44.11 27.25 72.16 34.6 125.48 7.35 53.3 20.54 154.85 20.54 154.85l-81.81 21.13s-.92-17.47-10.11-31.25c-9.19-13.78-13.78-27.56-22.98-79.04-9.19-51.46-23.9-133.27-30.33-165.44-6.43-32.17-100.18-411.74-100.18-411.74Z"
        style={{
          fill: '#245787',
        }}
      />
      <path
        d="M1472.82 771.74s-28.49 103.86-26.66 161.75c1.84 57.91 29.41 202.2 32.17 238.05 2.76 35.84-7.11 76.8-6.43 102.02.54 20.54 15.62 201.27 15.62 201.27l83.63 24.82s-10.11-22.05 5.51-35.84c15.62-13.78 10.11-52.38 7.35-107.53s-13.78-112.13-13.78-143.38 2.59-136.74 8.27-158.09c9.16-34.39 34.93-121.33 30.33-118.56s0-157.16 0-157.16l-136.03-7.35h.02Z"
        style={{
          fill: '#245787',
        }}
      />
      <path
        d="M1764.76 461.67c21.2 29.25 68.2 188.01 72.16 223.16 4.05 35.92-37.14 100.23-47.12 112.1-12.81 15.22-69.05 24.96-69.05 24.96l-19.74-56.29s38.76-51.91 50.45-71.66c11.7-19.74-38.76-116.25-38.76-116.25l52.05-115.99v-.02ZM1458.25 437.28s-21.93 0-29.98 20.47-39.49 92.13-53.37 132.33c-13.89 40.22-29.25 56.29-19.01 87.73 10.24 31.44 14.86 86.46 33.13 101.83 18.28 15.35 45.1 19.55 45.1 19.55l18.28-78.23s-20.51-48.54-21.97-58.78c-1.46-10.24 56.33-73.57 56.33-73.57l-28.52-151.34h.02Z"
        style={{
          fill: '#e6ab00',
        }}
      />
      <path
        d="M1589.26 516.45s1.29-20.98-9.47-39.59c-24.45-42.3-19.14-69.21-19.14-69.21s-67.55 15.14-91.68 18.79c-24.12 3.65-42.16 13.76-42.89 51.06-.73 37.3 30.71 148.42 23.39 195.94-7.32 47.52-37.3 96.51-32.17 120.63 5.11 24.12 29.25 32.9 28.52 43.87-.73 10.97 1.32 41.1 1.32 41.1s69.59 15.94 117.85 14.48c48.26-1.46 167.07-14.48 167.07-14.48s-5.58-28.19 6.85-36.97c12.43-8.78 17.08-11.73 17.83-35.12.73-23.39-29.42-89.66-22.11-132.8 7.32-43.14 3.65-110.4 21.2-149.15 17.55-38.76 21.2-58.5 3.65-70.2-17.55-11.7-106.38-41.87-106.38-41.87s-2.33 14.25-13.71 30.97c-9.75 14.32-26.09 27.29-30.81 34.71-10.24 16.09-12.86 36.97-12.86 36.97l-6.45.85-.02.02Z"
        style={{
          fill: '#e6ab00',
        }}
      />
      <g
        style={{
          clipPath: 'url(#bigsister-b)',
        }}
      >
        <path
          d="M1589.71 511.67s-7.72 98.09-15.69 125.78c-7.98 27.69-18.34 70.09-20.21 101.05-1.88 30.97-3.28 162.41-3.28 162.41h8.74s-1.09-131.22 1.72-161.51c2.76-29.65 12.53-77.76 18.3-96.18 9.23-29.46 16.04-128.94 16.04-128.94l-5.63-2.62.02.02Z"
          style={{
            fill: '#f9cec6',
          }}
        />
      </g>
      <path
        style={{
          fill: 'none',
        }}
        d="m1588.97 513.58-1.97 42.44 19.94-3.21-10.1-40.15-7.87.92z"
      />
      <path
        d="M1566.98 216.37c-13.78.68-24.35-.17-34.81 9.92-10.46 10.1-12.15 18.02-18.04 20.75s-18.68 10.65-13.66 25.93c5.02 15.29 20.16 9.54 22.16 17.47 2 7.94 3.44 22.44 5.25 34.97s9.61 32.19 9.61 32.19 120.56-20.84 119.47-20.63c-1.09.23-.97-23.32-2.03-34.1-1.06-10.78-2.03-17.41 1.16-18.44 3.2-1.03 18.21-2.52 15.89-19.48-2.33-16.98-10.71-12.69-12.48-21.41-1.79-8.74-4.24-18.86-18.91-23.83-14.67-4.97-17.78.23-24-4.21-6.22-4.41-7.7-9.8-21.03-10.11-13.35-.31-18.77 10.51-28.54 10.98h-.03Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1580.21 269.59c-21.71 3.3-35.66 10.06-39.71 14.49-9.56 10.45 2.54 18.07-3.25 28.75-5.79 10.67-.7 27.15-.7 27.15s-4.21-11.28-12.43-8.85-10.36 16.15-4.41 26.7c5.94 10.55 11.38 18.25 15.9 18.37 4.21.12 7.13-4.12 7.13-4.12s4.31 21.12 14.29 32.74c9.96 11.63 30.87 22.91 39.02 22 8.17-.9 21.13-2.42 28.54-6.97 7.42-4.55 27.44-25.34 30.08-38.39s.24-28.5.24-28.5 7.89 3.32 11.57-2.75c3.68-6.07 8.99-13.24 7.49-24.31-1.51-11.07-2.85-16.08-10.5-14.51s-10.5 17.33-10.5 17.33-2.87-21.41-7.4-26.94c-4.54-5.53-7.09-5.01-9.59-11.7-2.5-6.69-3.65-17.85-18.32-20.93-14.67-3.08-37.47.45-37.47.45l.02-.02Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1599.64 311.78s10.5-7.21 21.38-7.49c9.54-.24 13.43 2.94 13.43 2.94l2.02-4.54s-5.93-4.47-20.13-5.49c-14.2-1.03-20.42 5.79-20.42 5.79l3.74 8.79h-.02ZM1581.75 309.3s-15.02.4-22.98 5.68c-7.93 5.27-9.16 8.46-9.16 8.46l-4.08-2.83s2.76-6.9 14.37-15.14 20.28-7.18 20.28-7.18l1.56 11Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1570.51 377.27c.17 3.35 18.13 18.6 33.66 16.41 15.54-2.19 19.74-10.46 19.59-14.86s-3.02-14.16-11.47-12.18c-8.45 1.98-12.77 5.35-12.77 5.35s-5.47-2.95-12.17-2.22c-7.68.83-17.1 2.64-16.84 7.51Z"
        style={{
          fill: '#de9766',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1606.01 319.81 19.12.84-.15-7.37-18.67.95-.3 5.58zM1559.91 332.19l17.43-8.08-1.93-5.79-18.23 6.78 2.73 7.09z"
      />
      <path
        d="M1570.14 325.08c-3.49.56-5.58 3.3-4.9 6.69s3.13 4.43 6.29 4.14c3.74-.35 5.49-2.92 5.14-6.48-.24-2.52-2.95-4.92-6.55-4.34h.02ZM1614.62 318.65c-3.49.56-5.58 3.3-4.9 6.69.68 3.39 3.13 4.43 6.29 4.14 3.74-.35 5.49-2.92 5.14-6.48-.24-2.52-2.95-4.92-6.55-4.34h.02Z"
        style={{
          fill: '#1c3628',
        }}
      />
    </svg>
  )
}

export default BigSisterEnd
